import ecommerce from '../assets/Ecommerce.png'
import greenMind from '../assets/greenMind.png'
import flower from '../assets/flower.png';
import gym from '../assets/gym.png';
import anime from '../assets/anime.png';
import Moviehub from '../assets/MovieHub.png';
import organic from '../assets/organic.png';
import quiz from '../assets/quiz.png';
import recipefinder from '../assets/recipefinder.jpeg';
import styylleHive from '../assets/styylle-hive.jpeg'
import ExpenseTracker from '../assets/Expense Tracker.png'
import License from '../assets/license.jpg'

export const Projectdata =[
    {
        _id:11,
        pic:License,
        title:"License Plate Recognition Using GANs",
        tech:["Python", "GANs","Easy OCR"],
        description:"A project that uses GAN's to enhance license plate recognition. It generates synthetic license plates to improve model accuracy.",
        link:"https://github.com/vasuki-elango/License_Plate_Detection_Using_GAN",
        demo:""
    },
    {
        _id:0,
        pic:styylleHive,
        title:"StYyLle Hive",
        tech:["MERN Stack", "Tailwind CSS", "Redux"],
        demo:"https://styylle-hive-client.vercel.app/",
        description:"A MERN e-commerce app with a clean UI and admin panel for managing products and orders. Simple and user-friendly.",
        link:""
    },
    {
        _id:1,
        pic:Moviehub,
        title:"MovieHub",
        tech:["React", "Bootstrap", "TMDB API"],
        description:"A React-based movie discovery app , letting users search movies, view details, and explore trending titles using the TMDB API.",
        link:"",
        demo:"https://vasuki-elango.github.io/MovieHub/"
    },
    {
        _id:2,
        pic:greenMind,
        title:"GreenMind UI/UX Desgin",
        tech:["Figma", "UI/UX Design","Wireframe"],
        description:"A plant care app UI/UX project with a clean, intuitive design focusing on user experience and accessibility.",
        link:"",
        demo:"https://www.figma.com/proto/WfokuNFRf3pX6wFEyDHp84/Plant?node-id=0-1&t=XlBixR7NzEDXjjei-1"
    },
    {
        _id:10,
        pic:ExpenseTracker,
        title:"Expense Tracker",
        tech:["MERN Stack", "Tailwind CSS","Recharts"],
        description:"A MERN finance app to track income, expenses, visualize spending, and manage budgets in an intuitive dashboard.",
        link:"",
        demo:"https://expense-tracker-client-alpha.vercel.app"
    },
    {
        _id:3,
        pic:flower,
        title:"Flower Shop",
        tech:["React", "Tailwind CSS", "Redux"],
        description:"A responsive flower shop app with product filtering and browsing features. Built using React and Tailwind CSS.",
        link:"",    
        demo:"https://vasuki-floweshop.netlify.app/"
    },
    {
        _id:4,
        pic:organic,
        title:"Organic Site",
        tech:["HTML", "Responsive", "Bootstrap"],
        description:"An HTML and Bootstrap e-commerce site for organic products. Responsive, clean design with user-friendly layout and reviews.",
        link:"",
        demo:"https://vasuki-organic-site.netlify.app/"
    },
    {
        _id:5,
        pic:recipefinder,
        title:"Recipe Finder",
        tech:["React", "Tailwind CSS", "Responsive"],
        description:"Search and explore recipes with ingredients and instructions. Built with React and styled using Tailwind CSS.",
        link:"",
        demo:"https://vasuki-elango.github.io/Recipe-Finder/"
    },
    {
        _id:6,
        pic:quiz,
        title:"Quiz Application",
        tech:["React", "Tailwind CSS", "Redux"],
        description:"A quiz app with multiple-choice questions, timer, and score tracking. Made with React and Tailwind CSS.",
        link:"",
        demo:"https://vasuki-elango.github.io/QuizApplication/"
    },
    {
        _id:7,
        pic:gym,
        title:"Gym UI/UX Desgin",
        tech:["UI/UX", "Wireframe", "Figma"],
        description:"A gym website UI/UX design focused on intuitive layout, visual appeal, and enhanced user experience using Figma.",
        link:"",
        demo:"https://www.figma.com/proto/tjhq4D06q6o6kJOUiA3Tp7/GYM-WEBSITE?node-id=0-1&t=9j7ytzAKvZl2i7fC-1"
    },
    {
        _id:8,
        pic:anime,
        title:"Anime UI/UX Desgin",
        tech:["UI/UX", "Wireframe", "Figma"],
        description:"An anime website design project built in Figma, focusing on user-friendly layout and visually appealing interface.",
        link:"",
        demo:"https://www.figma.com/proto/KS88bXjpcoQKAeDWm2Bvwm/anime?node-id=0-1&t=0gnAeZ4x5bKHOmlj-1"
    },
    {
        _id:9,
        pic:ecommerce,
        title:"FIFASH UI/UX Desgin",
        tech:[ "Wireframe", "Figma","Responsive"],
        description:"A responsive e-commerce UI/UX design project built in Figma, focused on user experience and modern aesthetics.",
        link:"",
        demo:"https://www.figma.com/proto/fK7sX2Oxw2VKGXZOnEQMeS/E-Commerce?node-id=0-1&t=KB28swWVGKCi4Ahu-1"
    },
    
]       